import { object, string, number, array } from 'yup';
import { errorMessages } from 'screens/Mutations/constants';
import {
  currentLoanPartSchema,
  endDateInterestDeduction,
} from 'screens/Mutations/components/DismissalJointLiabilityMutation/schema/loan';

const loanSchemaBase = object().shape({
  loanNumber: number().nullable(),
  amount: number().typeError(errorMessages.number).required(errorMessages.required),
  amountRaise: number().typeError(errorMessages.number).required(errorMessages.required),
  reasonIncrease: string().required(errorMessages.required),
  changeLifeInsurancePolicy: string().required(errorMessages.required).nullable(),
  changeCurrentMortgage: string().required(errorMessages.required).nullable(),
});

export const loanSchema = object({
  financingLoan: loanSchemaBase,
  currentLoanParts: array().when('financingLoan.changeCurrentMortgage', {
    is: (val: any) => val === 'yes',
    then: currentLoanPartSchema(),
  }),
  newLoanParts: array().of(
    object().shape({
      repaymentType: string().required(errorMessages.required),
      NHGGuarantee: string().required(errorMessages.required).nullable(),
      loanAmount: number().typeError(errorMessages.number).required(errorMessages.required),
      taxBox: number().typeError(errorMessages.required).required(errorMessages.required),
      interestPercentage: number().typeError(errorMessages.number).required(errorMessages.required),
      endDateInterestDeduction: endDateInterestDeduction(),
      newDuration: number().typeError(errorMessages.number).required(errorMessages.required),
      fixedRatePeriod: number().typeError(errorMessages.number).required(errorMessages.required),
    })
  ),
});
